<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" type="danger" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
            <el-table-column prop="operation" fixed="right" label="操作" width="270">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="scope.row.status != 1 && scope.row.status != 2 && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                  <el-button v-else-if="scope.row.status == 2  && tableAcl.indexOf('Modify') != -1" type="text" v-preventReClick @click="handleEditdate(scope.row)" class="margin-left20 color-blue">修改</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <el-button v-if="scope.row.status == 2" type="text" v-preventReClick @click="handleRefresh(scope.row)" class="margin-left20 color-blue">刷新</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>

        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <!-- <el-table-column prop="hospitalName" width="175" label="医院名称"></el-table-column> -->
        <el-table-column prop="no" fixed width="175" label="合同编号">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="name" width="170" label="合同名称"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号"></el-table-column>
        <el-table-column show-overflow-tooltip prop="productRegistCertName" label="注册证名称"></el-table-column> -->
        <el-table-column show-overflow-tooltip prop="distributionBatchName" width="170" label="集采批次"></el-table-column>
        <el-table-column prop="totalAmount" width="95" label="合同金额"></el-table-column>
        <el-table-column prop="dimensionTypeName" width="95" label="合同维度"></el-table-column>
        <el-table-column label="开始日期" width="120">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.startDate), "{y}-{m}-{d}") }}
          </template>
        </el-table-column>
        <el-table-column label="结束日期" width="120">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.endDate), "{y}-{m}-{d}") }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="totalNumber" width="95" label="合同量"></el-table-column> -->
        <el-table-column prop="stateName" width="100" label="合同状态"></el-table-column>
        <!-- <el-table-column prop="createdUserName" width="80" label="申请人"></el-table-column> -->
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="createdTime"  label="创建时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column> -->
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames?scope.row.approverNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="270">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="scope.row.status != 1 && scope.row.status != 2 && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-else-if="scope.row.status == 2  && tableAcl.indexOf('Modify') != -1" type="text" v-preventReClick @click="handleEditdate(scope.row)" class="margin-left20 color-blue">修改</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <el-button v-if="scope.row.status == 2" type="text" v-preventReClick @click="handleRefresh(scope.row)" class="margin-left20 color-blue">刷新</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  

    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetSpdContracts,
  RemoveSpdContract,
  RefreshSpdContract
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  SpdContractStateOptions,
  ApproveStatusOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetSpdContracts,
      RemoveAction: RemoveSpdContract,
      // exportAction: ExportAcceptOutStock,
      editPath: "spd-contract-edit",
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1
      },
      SpdContractStateOptions: SpdContractStateOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "合同名称",
          type: "input",
          code: "keyWord",
        },
        {
          name: "集采批次",
          type: "select",
          code: "distributionBatchId",
          filterMethod: this.getDistributionBatchs,
          data: [],
        },
        {
          name: "合同状态",
          type: "select",
          code: "states",
          multiple: true,
          data: SpdContractStateOptions,
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "注册证号",
          type: "input",
          code: "productRegistCertNo",
        },
        {
          name: "注册证名称",
          type: "input",
          code: "productRegistCertName",
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
      ],
    };
  },
  methods: {
    handleRefresh(row){
      RefreshSpdContract({id:row.id}).then(res=>{
        if(res.successful){
          this.$message({
          message: '刷新成功',
          type: 'success'
        });
        }
      })
    },
    handleEditdate(row){
      this.routePushWithParams("/" + this.editPath, this.query, { formMode: 0, id: row.id,isEdit: 1 });
    }
  },
  created () {
  },
  mounted () {
  },
};
</script>

<style lang="scss" scoped></style>
